// Period windows for Proxy pages (Intake Queue, Completed), anchored on the
// demo's fixed "today" (PROXY_SEED_TODAY).
import { PROXY_SEED_TODAY } from '../data/mockProxyJobs';
import { windowBounds, inWindow, type ScopeValue, type WindowBounds, type WindowCounts } from './timeWindow';

// PROXY_SEED_TODAY (2026-06-01) happens to be both a Monday and the 1st of
// the month, so the shared calendar-boundary windowBounds() collapses "This
// Week"/"This Month" to the exact same single day as "Today" — hiding
// seeded backlog (e.g. shortage follow-ups dated "Yesterday"). Use a
// trailing lookback for those two presets instead, so they actually widen
// the view; "Today" and a custom range keep the shared, exact semantics.
export function proxyWindowBounds(scope: ScopeValue): WindowBounds {
  if (scope.window !== 'week' && scope.window !== 'month') return windowBounds(scope, PROXY_SEED_TODAY);
  const days = scope.window === 'week' ? 7 : 30;
  const d = new Date(`${PROXY_SEED_TODAY}T00:00:00`);
  d.setDate(d.getDate() - (days - 1));
  const pad = (n: number) => String(n).padStart(2, '0');
  return { start: `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`, end: PROXY_SEED_TODAY };
}

export function proxyWindowCounts(rows: { intake_date: string | null }[]): WindowCounts {
  const t = proxyWindowBounds({ window: 'today' });
  const w = proxyWindowBounds({ window: 'week' });
  const m = proxyWindowBounds({ window: 'month' });
  let today = 0, week = 0, month = 0;
  for (const r of rows) {
    if (inWindow(r.intake_date, t)) today++;
    if (inWindow(r.intake_date, w)) week++;
    if (inWindow(r.intake_date, m)) month++;
  }
  return { today, week, month };
}
